module.exports = __webpack_public_path__ + "img/collection-engagementRingsDiamonds.65d08d0.jpg";